/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The events of one entity type sitting in a single processing status
 */
export interface GuestyEventStateSummary { 
    /**
     * The number of events in this status
     */
    event_count?: number;
    /**
     * The number of distinct Guesty entities affected by those events
     */
    entity_count?: number;
    oldest_event_timestamp?: string;
    latest_event_timestamp?: string;
}

